import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLlipseCoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 76,
	viewBox: "0 0 76 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 38,
			cy: 38,
			r: 37.5,
			fill: "#FF5F5F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 37.9988,
			cy: 38,
			r: 32.0984,
			fill: "#EF4444"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.3182 46.8333L53.8003 34.9492L47.5881 31.4379L42.9965 39.5408H33.2732L28.6817 31.4379L22.1992 34.9492L28.9515 46.8333H47.3182Z",
			fill: "#FF5F5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.1487 25.1667L33.5666 29.7517L38.1513 34.334L42.7337 29.7491L38.1487 25.1667Z",
			fill: "#FF5F5F"
		})
	]
});
export default SvgLlipseCoin;
